import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M0 0h48v48H0z" }),
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "nonzero",
        d: "m19.636 3 3.086 3.086L7.451 21.359 48 21.358v4.365l-40.55.002 15.272 15.27-3.086 3.086L.64 25.085a2.183 2.183 0 0 1 0-3.086L19.636 3z"
      })
    ], -1)
  ])))
}
export default { render: render }